<script>
import {Api} from '../../Api.js'
import Button from "../Button.vue";
export default {
  name: 'modalFile',
  props: ['selectedImage'],
  components: {Button},
  data: function () {
    return {
      costs: 0.25,
      config: null,
      imagePreviewBase64: null,
      transparentImage: null,
      defaultBg: "pattern",
      actions: [],
      prompt: null,
      applyFiltersDisabled: null,
      actionsSource: [
        {id:'remove-background', name:'Transparence', description:'Supprime le fond automatiquement'},
        {id:'super-resolution', name:'Améliorer la résolution', description:'Augmente la netteté et la résolution de l\'image'},
        //{id:'reimagine', name:'Réimaginer le fond', description:'Augmente la netteté et la résolution de l\'image'},
        //{id:'remove-text', name:'Suppression du texte'},
        //{id:'replace-background', name:'Intégrer un fond'},
      ]
    }
  },
  mounted: function(){
    console.log("coucou1", this.selectedImage)
  },
  created: function() {
    //this.initialize();
    console.log("coucou2", this.selectedImage)
  },
  methods: {
    changeBackground(color){
      this.defaultBg = color;
    },
    doIt(){
      let self = this;
      this.applyFiltersDisabled = true;
      Api().get(
      'media/remove-bg/preview/' + this.selectedImage.id + "?actions=" + this.actions.join(',') + "&prompt=" + this.prompt,
      {
        responseType: 'text'
      })
      .then(function (response) {
        $("#loader").stop().hide();
        console.log(response.data)
        self.imagePreviewBase64 = response.data;
        self.applyFiltersDisabled = false;
      });

    },
    getTransparentImage(){
      let self = this;
      Api().get('media/remove-bg/full/'+this.selectedImage.id).then((response) => {
        if( response.data ){
          self.transparentImage = response.data
        }
      })
    },
    close() {
      this.transparentImage = null
      this.imagePreviewBase64 = null
      this.$emit('close');
    },
    validate(){
      Api().get('media/remove-bg/full/'+this.selectedImage.id).then((response) => {
        if( response.data ){
          this.$emit('validate', response.data);
        }
      })
    },
  },
  watch: {
    'selectedImage'(newVal, oldVal) {
      this.transparentImage = null
      this.imagePreviewBase64 = null
    },
    'actions'(newVal, oldVal) {
      console.log("options", newVal)
      if( newVal.length > 0 ){
        this.applyFiltersDisabled = false
      }else{
        this.applyFiltersDisabled = true
      }
    }
  }
};
</script>
<template>
  <transition name="modal-fade">
    <div class="modal-backdrop">
      <div class="modal-overlay" @click="close()"></div>
      <div class="modal"
           role="dialog"
           aria-labelledby="modalTitle"
           aria-describedby="modalDescription">

        <article>
          <header
              class="modal-header"
              id="modalTitle">
            <figure><i class="icon icon-icon_file-edit"></i></figure>
            <div>
                            <span class="breadcrumb">
                                Galerie médias <i class="icon icon-icon_arrow-right"></i> Edit
                            </span>
              <h1>Edition du média</h1>
            </div>
            <div class="spacer"></div>
            <div class="buttons">
              <button @click="close()" class="bt-back"><span><i class="icon icon-icon_close"></i></span></button>
              <button @click="validate()" class="bt-primary bt-save"><span><i class="icon icon-icon_tick"></i></span></button>
            </div>
          </header>
          <main class="modal-changes-status modal-overflow" style="padding: 3em;">

            <fieldset>


              <div style="max-width: 600px;margin: auto;" :class="defaultBg">
                <img v-if="imagePreviewBase64" :src="imagePreviewBase64" style="aspect-ratio: 1;width: 100%;object-fit: contain;">
                <img v-if="selectedImage && imagePreviewBase64 == null" :src="selectedImage.url" style="aspect-ratio: 1;width: 100%;object-fit: contain;">
              </div>

              <div class="background-previews">
                <div class="background-previews-pattern" @click="changeBackground('pattern')" :class="{'active':defaultBg=='pattern'}"></div>
                <div class="background-previews-white" @click="changeBackground('white')" :class="{'active':defaultBg=='white'}"></div>
                <div class="background-previews-black" @click="changeBackground('black')" :class="{'active':defaultBg=='black'}"></div>
              </div>

              <hr>

              <form-checklist :label="'Filtres disponibles'" :hint="'Un coût de CHF '+costs+' est facturé par filtre coché. Si le résultat vous convient, enregistrer vos modifications.'" v-model="actions" :options="actionsSource"
                              multiple="true"></form-checklist>

              <button @click="doIt" class="bt bt-create" :disabled="applyFiltersDisabled"><span>Appliquer les filtres (CHF {{ (actions.length * costs)|formatNumber }})</span></button>

            </fieldset>


          </main>
        </article>

      </div>
    </div>
  </transition>
</template>
<style scoped>
.background-previews{
  display: flex;
  margin: 10px auto;
  justify-content: center;
  justify-items: center;
}
.background-previews > *{
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin: 4px;
  border: 3px solid #888;
  box-shadow: 0px 0px 5px rgba(0,0,0,0.1);
  cursor: pointer;
}
.actions{
  display: flex;
  margin: 10px auto;
  justify-content: center;
  justify-items: center;
}
.actions label{
  margin: 0 10px;
  position: relative;
  padding-left: 30px;
  border: 1px solid #ddd;
  border-radius: 6px;
  display: flex;
  align-items: center;
}
.actions label input[type="checkbox"]{
  position: absolute;
  top: 5px;
  left: 5px;
}
.actions button{
  margin: 0;
}

.background-previews .active{
  border: 3px solid #000;
}
.background-previews-pattern{
  background-image: linear-gradient(45deg, #d8d8d8 25%, transparent 25%), linear-gradient(-45deg, #d8d8d8 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #d8d8d8 75%), linear-gradient(-45deg, transparent 75%, #d8d8d8 75%);
  background-size: 6px 6px;
  background-position: 0 0, 0 3px, 3px -3px, -3px 0px;
}
.background-previews-white{
  background: #fff;
}
.background-previews-black{
  background: #000;
}
.pattern{
  background-image: linear-gradient(45deg, #d8d8d8 25%, transparent 25%), linear-gradient(-45deg, #d8d8d8 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #d8d8d8 75%), linear-gradient(-45deg, transparent 75%, #d8d8d8 75%);
  background-size: 20px 20px;
  background-position: 0 0, 0 10px, 10px -10px, -10px 0px;
}
.white{
  background: #fff;
}
.black{
  background: #000;
}
</style>


// WEBPACK FOOTER //
// src/components/form/ModalFile.vue